import { call, put, select } from 'redux-saga/effects';
import { iActionCreate } from '~/domain/interfaces/redux/administrator/create';
import { CreateAdministrator } from '~/domain/usecases/administrator/remote';
import { makeRemoteCreateAdministrator } from '~/main/factories/usecases/administrator/CreateAdministratorFactory';
import {
  createSuccess,
  createFailed,
} from '~/data/store/reducer/administrator/actions/create';
import { makeReduxActiveMessage } from '~/main/factories/usecases/message/Update';
import { MessageOptions } from '~/domain/interfaces/redux/message';
import { History } from '~/main/routes';
import { closeModal } from '~/utils/closeModal';

export function* onCreate(action: iActionCreate) {
  const remoteCreateAdministrator = makeRemoteCreateAdministrator();

  try {
    const response: CreateAdministrator.Model = yield call(
      remoteCreateAdministrator.create,
      action.payload,
    );

    makeReduxActiveMessage().active({
      active: MessageOptions.userCreateSuccess,
      actionOk: () => {
        History.back();
        closeModal();
      },
    });

    yield put(
      createSuccess({
        ...response,
      }),
    );
  } catch (e) {
    yield put(createFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onCreateSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onCreateFailed() {}
